"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
    // En dev, l'écran générique ne dit rien : la stack part dans la console du
    // navigateur, que le serveur dev recopie dans ses logs (`docker logs
    // ogryn_webapp` → lignes `[browser]`). Sans ça un crash client se
    // diagnostique à l'aveugle.
    if (process.env.NODE_ENV !== 'production') {
      console.error('[ogryn] global-error:', error.message, '\n', error.stack);
    }
  }, [error]);

  return (
    <html lang="en">
      <body>
        {process.env.NODE_ENV !== 'production' ? (
          <pre style={{ padding: 16, fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {error.message}{'\n\n'}{error.stack}
          </pre>
        ) : (
          /* `NextError` is the default Next.js error page component. Its type
          definition requires a `statusCode` prop. However, since the App Router
          does not expose status codes for errors, we simply pass 0 to render a
          generic error message. */
          <NextError statusCode={0} />
        )}
      </body>
    </html>
  );
}
